import { render, staticRenderFns } from "./english-big-effect-report.vue?vue&type=template&id=082a8252&scoped=true&"
import script from "./english-big-effect-report.vue?vue&type=script&lang=js&"
export * from "./english-big-effect-report.vue?vue&type=script&lang=js&"
import style0 from "./english-big-effect-report.vue?vue&type=style&index=0&id=082a8252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082a8252",
  null
  
)

export default component.exports